import { render, staticRenderFns } from "./prebuild-review.vue?vue&type=template&id=575ee934&scoped=true&"
import script from "./prebuild-review.vue?vue&type=script&lang=js&"
export * from "./prebuild-review.vue?vue&type=script&lang=js&"
import style0 from "./prebuild-review.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./prebuild-review.vue?vue&type=style&index=1&id=575ee934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575ee934",
  null
  
)

export default component.exports